import { createEvent } from "effector";
const OnChangeSortEvt = () => {
    const onChangeSortEvt = createEvent("OnChangeSortEvt");
    onChangeSortEvt.watch(() => console.log("OnChangeSortEvt"));
    return onChangeSortEvt;
};
export default OnChangeSortEvt;
//# sourceMappingURL=OnChangeSortEvt.js.map